import { render } from "./HeaderLums.vue?vue&type=template&id=dd50a07a&scoped=true"
import script from "./HeaderLums.vue?vue&type=script&lang=js"
export * from "./HeaderLums.vue?vue&type=script&lang=js"

import "./HeaderLums.vue?vue&type=style&index=0&id=dd50a07a&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd50a07a"]])

export default __exports__